// extracted by mini-css-extract-plugin
export default {"tab":"OnPrem_tab__DcpfH"};